import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useUserContext } from '../context/UserContext';
import { useRolesContext } from '../context/RolesContext';
import { useEffect } from 'react';

const ModalCreatetUser = ({ onClose, first, object }) => {
  const {firstUser, createUser, updateUser, deleteUser, roleId } = useUserContext();
  const { roles } = useRolesContext();
  const [login, setLogin] = useState(object?object.login:'');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [name, setName] = useState(object?object.name:'');
  const [email, setEmail] = useState(object?.email || '');
  const [comment, setComment] = useState(object?object.comment:'');
  const [confirmError, setConfirmError] = useState(false);
  const [role, setRole] = useState(object?object.role:roles.length>0?roles[0]._id:"");
   const [roleType, setRoleType] = useState(null)

  useEffect(()=>{
          if (roles){
            let idx = roles.findIndex((r)=>{return r._id===roleId});
            if (idx !== -1){
              setRoleType(roles[idx].type)
            }
          }
        }, [roles])
  // Обработчик сохранения комментария
  const handleSave = () => {
    debugger
    let func = createUser
    if (first === 0) {
      func = firstUser
    }
    if (object){
      let cred = {};
      if (password!=='' && password === confirmPassword){
        cred.password = password
      }else {
        setConfirmError(true)
      }
      cred.login = login;
      cred.name = name;
      cred.email = email;
      cred.comment = comment;
      cred._id = object._id;
      cred.role = role
      updateUser(cred)
      onClose();
      return;
    }
    if (password === confirmPassword){
      func({login: login, password:password, name:name, email: email, comment:comment, role: role})
      onClose();
    } else {
      setConfirmError(true)
    }
    
  };
 const handleDelete = () => {
    deleteUser(object._id);
    onClose();
  }
  // Обработчик закрытия окна
  const handleClose = () => {
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="task-modal admin-modal">
        <header className="task-modal__header">
          <h2 className="task-modal__title">
            {!object ? 'Создание пользователя' : 'Редактирование пользователя'}
          </h2>
          <button className="task-modal__close" onClick={handleClose}>×</button>
        </header>

        <div className="task-modal__body">
          <div className="admin-modal__grid">
            <div className="admin-modal__field">
              <label className="admin-modal__label" htmlFor="login">Логин</label>
              <input
                className="admin-modal__input"
                id="login"
                required
                value={login}
                onChange={e => setLogin(e.target.value)}
              />
            </div>
            <div className="admin-modal__field">
              <label className="admin-modal__label" htmlFor="name">Имя (ФИО)</label>
              <input
                className="admin-modal__input"
                id="name"
                required
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>
            <div className="admin-modal__field">
              <label className="admin-modal__label" htmlFor="email">Электронная почта</label>
              <input
                className="admin-modal__input"
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="user@example.com"
              />
            </div>
            <div className="admin-modal__field">
              <label className="admin-modal__label" htmlFor="password">Пароль</label>
              <input
                className="admin-modal__input"
                type="password"
                id="password"
                required
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </div>
            <div className="admin-modal__field">
              <label className="admin-modal__label" htmlFor="confirmPassword">Подтверждение пароля</label>
              <input
                className={`admin-modal__input${confirmError ? ' admin-modal__input--error' : ''}`}
                type="password"
                id="confirmPassword"
                required
                value={confirmPassword}
                onChange={e => { setConfirmPassword(e.target.value); setConfirmError(false); }}
              />
              {confirmError && <span className="admin-modal__error">Пароли не совпадают</span>}
            </div>
            <div className="admin-modal__field">
              <label className="admin-modal__label" htmlFor="role">Роль</label>
              <select
                className="admin-modal__select"
                id="role"
                value={role}
                onChange={e => setRole(e.target.value)}
              >
                {roles.map(r => (
                  <option key={r._id} value={r._id}>{r.ruName}</option>
                ))}
              </select>
            </div>
            <div className="admin-modal__field admin-modal__field--full">
              <label className="admin-modal__label" htmlFor="comment">Комментарий</label>
              <textarea
                className="admin-modal__textarea"
                id="comment"
                value={comment}
                onChange={e => setComment(e.target.value)}
              />
            </div>
          </div>
        </div>

        <footer className="task-modal__footer">
          <button className="task-modal__btn task-modal__btn--ghost" onClick={handleClose}>Отмена</button>
          <button className="task-modal__btn task-modal__btn--primary" onClick={handleSave}>Сохранить</button>
          {(roleType === 'firstAdmin' || roleType === 'admin') && object && (
            <button className="task-modal__btn task-modal__btn--danger" onClick={handleDelete}>Удалить</button>
          )}
        </footer>
      </div>
    </div>
  );
};

// Пропсы, обязательные для корректной работы
ModalCreatetUser.propTypes = {
  // first: PropTypes.func.first,
  onClose: PropTypes.func.isRequired,
};

export default ModalCreatetUser;